<template>
  <div>
    <b-form-group label="Nome:">
      <b-form-input
        v-model="role.name"
        placeholder="Nome"
        :state="validateState('name')"
      ></b-form-input>
      <b-form-invalid-feedback
        >Nome é um campo obrigatório.</b-form-invalid-feedback
      >
    </b-form-group>

    <b-form-group label="Permissões:">
      <b-form-checkbox-group
        v-model="selected_permissions"
        name="permissoes"
        v-if="permissions"
      >
        <b-row
          v-for="(list_permission, key) in list_permissions"
          :key="'list' + key"
          class="row-permissions"
        >
          <b-col cols="12" class="row-permissions-name">{{
            list_permission.label
          }}</b-col>
          <b-col
            v-for="(permission, key) in list_permission.permissions"
            :key="'permission' + key"
            cols="3"
          >
            <b-form-checkbox :value="permission.id">{{
              permission.label
            }}</b-form-checkbox>
          </b-col>
        </b-row>
      </b-form-checkbox-group>
    </b-form-group>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { mapActions, mapState } from "vuex";
import _ from "lodash";

export default {
  mixins: [validationMixin],
  data: () => ({
    permissions: null,
  }),
  validations: {
    role: {
      name: {
        required,
        minLength: minLength(3),
      },
    },
  },
  computed: {
    ...mapState("acl", ["role"]),
    selected_permissions: {
      set(ids) {
        let permissions = [];

        ids.forEach((id) => {
          let permission = _.find(this.permissions, ["id", id]);
          if (permission) {
            permissions.push(permission);
          }
        });

        this.role.permissions = permissions;
      },
      get() {
        let permissions = [];
        this.role.permissions.forEach((permission) => {
          permissions.push(permission.id);
        });
        return permissions;
      },
    },
    list_permissions() {
      let list = [];
      let permission_add = {
        label: null,
        permissions: [],
      };

      this.permissions.forEach((permission) => {
        let name = permission.name.split(":");
        let label = permission.label.split("-");

        if (name[0] != permission_add.name) {
          if (permission_add.permissions.length) {
            list.push(permission_add);
          }

          permission_add = {
            name: name[0],
            label: label[0].trim(),
            permissions: [],
          };
        }

        permission.label = label[1].trim();
        permission_add.permissions.push(permission);
      });

      if (permission_add.permissions.length) {
        list.push(permission_add);
      }

      return list;
    },
  },
  methods: {
    ...mapActions("acl", ["ActionLoadPermissions"]),
    validateState(name) {
      const { $dirty, $error } = this.$v.role[name];
      return $dirty ? !$error : null;
    },
    isValid() {
      this.$v.role.$touch();
      return !this.$v.role.$anyError;
    },
  },
  async created() {
    this.permissions = await this.ActionLoadPermissions();
  },
};
</script>

<style lang="scss">
.row-permissions {
  margin-bottom: 0.5rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #ddd;

  .row-permissions-name {
    margin-bottom: 0.2rem;
  }
}

.custom-checkbox {
  padding-left: 2rem !important;

  .custom-control-label {
    &::after,
    &::before {
      left: -2rem !important;
    }
  }
}
</style>
